//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'HeadHuntingTextTabs',

	computed: {
		textTabItems() {
			return [
				{
					text: 'All',
					name: '',
					active: this.$route.path === '/head-hunting',
				},
				{
					text: 'Viewed',
					name: 'viewed',
					active: this.$route.path === '/head-hunting/viewed',
				},
				{
					text: 'Groups',
					name: 'groups',
					active: this.$route.path === '/head-hunting/groups',
				},
			];
		},
	},
};
